export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const getIndonesianISOString = () => {
  const date = new Date();
  const indonesianDate = new Date(date.getTime() + 7 * 60 * 60 * 1000);
  return indonesianDate.toISOString().replace("Z", "+07:00");
};

export const getInitialDate = (typeOfSales) => {
  const today = new Date();
  const indonesiaTime = new Date(
    today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" })
  );

  if (typeOfSales === "daily") {
    const day = String(indonesiaTime.getDate()).padStart(2, "0");
    const month = String(indonesiaTime.getMonth() + 1).padStart(2, "0");
    const year = indonesiaTime.getFullYear();
    return `${day}/${month}/${year}`;
  } else if (typeOfSales === "monthly") {
    const month = String(indonesiaTime.getMonth() + 1).padStart(2, "0");
    const year = indonesiaTime.getFullYear();
    return `${month}/${year}`;
  } else if (typeOfSales === "yearly") {
    return `${indonesiaTime.getFullYear()}`;
  }
  return "";
};

export const formatDateTransaction = (dateString, typeOfSales) => {
  switch (typeOfSales) {
    case "daily":
      const [year_daily, month_daily, day] = dateString.split("-");
      return `${day}/${month_daily}/${year_daily}`;
    case "monthly":
      const [year, month] = dateString.split("-");
      return `${month}/${year}`;
    case "yearly":
      return dateString;
    default:
      break;
  }
};

export const formatDateTransactionDetail = (dateString) => {
  const date = new Date(dateString);

  // Convert to Indonesian Time (WIB, UTC+7)
  const formattedDate = date.toLocaleString("id-ID", {
    weekday: "long", // Optional: Add the day of the week (e.g., "Sab")
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false, // Use 24-hour format
    timeZone: "Asia/Jakarta", // Jakarta time zone (UTC+7)
  });

  return formattedDate;
};

/**
 * Convert date format for `<input type="date" />`
 * @param {string} initialDate - this argument comes from the `getInitialDate("daily")` function with the `daily` type.
 */
export function toISODateInput(initialDate) {
  const [dd, mm, yyyy] = initialDate.split("/");
  return `${yyyy}-${mm}-${dd}`;
}
